import React from "react";
import { RankDisplay } from "./RankDisplay";
import { ClientInfo } from "./ClientInfo";
import { RevenueSection } from "./RevenueSection";
import { ContactInfo } from "./ContactInfo";
import { MetricDisplay } from "./MetricDisplay";

export const ClientCard = ({ data }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm p-2">
            <div className="flex justify-between gap-2">
                <div className="flex-initial w-5/6">
                    <div className="flex justify-between">
                        <div className="flex items-center">
                            <RankDisplay rank={data?.rank} />
                            <ClientInfo clientData={data?.client_data} />
                        </div>
                        <div className="flex flex-1 place-content-end">
                            <MetricDisplay data={data?.current_year_data} />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3 mt-2">
                        <RevenueSection
                            title="YTD"
                            revenue={data?.current_year_revenue}
                            budget={data?.current_year_budget}
                            isYTD={true}
                        />
                        <RevenueSection
                            title="PY"
                            revenue={data?.last_year_revenue}
                            budget={data?.last_year_budget}
                        />
                    </div>
                </div>

                <div className="flex-1 bg-[#EDF2F7] rounded-lg">
                    <ContactInfo data={data} />
                </div>
            </div>
        </div>
    );
};
